import React from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import {
  CollapsibleSectionBody,
  CollapsibleSectionCard,
  CollapsibleSectionHeader,
  CollapsibleSectionHeaderText,
  CollapsibleSectionToggle,
} from './WorkSpacePage.styles';
export { useWorkspacePageSections } from './useWorkspacePageSections';

type WorkspaceCollapsibleSectionProps = {
  title: React.ReactNode;
  hint?: string;
  expanded: boolean;
  onExpandedChange: (expanded: boolean) => void;
  children: React.ReactNode;
  'data-tour'?: string;
};

export const WorkspaceCollapsibleSection: React.FC<
  WorkspaceCollapsibleSectionProps
> = ({
  title,
  hint,
  expanded,
  onExpandedChange,
  children,
  'data-tour': dataTour,
}) => {
  const handleToggle = () => {
    onExpandedChange(!expanded);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleToggle();
    }
  };

  return (
    <CollapsibleSectionCard data-tour={dataTour}>
      <CollapsibleSectionHeader
        type="button"
        aria-expanded={expanded}
        onClick={handleToggle}
        onKeyDown={handleKeyDown}
      >
        <CollapsibleSectionHeaderText>{title}</CollapsibleSectionHeaderText>
        <CollapsibleSectionToggle aria-hidden>
          {expanded ? <FiChevronUp /> : <FiChevronDown />}
        </CollapsibleSectionToggle>
      </CollapsibleSectionHeader>
      {expanded && (
        <CollapsibleSectionBody>
          {hint ? <p>{hint}</p> : null}
          {children}
        </CollapsibleSectionBody>
      )}
    </CollapsibleSectionCard>
  );
};
